import { NavigationControl, ScaleControl, GeolocateControl } from 'react-map-gl';
//
import IconButton from '@mui/material/IconButton';
import { useQueryState } from 'nuqs';
import Iconify from 'src/components/iconify';

import { StyledMapControls } from './styles';

// ----------------------------------------------------------------------

type Props = {
  hideScaleControl?: boolean;
  hideGeolocateControl?: boolean;
  hideFullscreenControl?: boolean;
  hideGallery?: boolean;
  settingQuery: Function;
  hideNavigationControl?: boolean;
};

export default function MapControl({
  hideScaleControl,
  hideGeolocateControl,
  hideFullscreenControl,
  hideGallery,
  settingQuery,
  hideNavigationControl,
}: Props) {
  const [_, setIsMapOpen] = useQueryState('map');

  return (
    <>
      <StyledMapControls />

      {!hideGeolocateControl && (
        <GeolocateControl
          position="top-left"
          positionOptions={{ enableHighAccuracy: true }}
          trackUserLocation
        />
      )}

      {!hideScaleControl && <ScaleControl position="bottom-left" />}
      {!hideGallery && (
        <IconButton
          sx={{
            backgroundColor: '#000',
            px: 1, // Change this to your desired style
            borderRadius: 1,
            color: 'white',
            position: 'absolute',
            top: 8,
            right: 4,
          }}
          onClick={() => setIsMapOpen(null)}
        >
          <Iconify width={20} icon="material-symbols:gallery-thumbnail" />
        </IconButton>
      )}

      {/* {!hideGallery && (
        <IconButton
          sx={{
            backgroundColor: '#000',
            px: 1, // Change this to your desired style
            borderRadius: 1,
            color: 'white',
            position: 'absolute',
            bottom: 30,
            right: 20,
          }}
          href="/submit/"
        >
          <Iconify width={20} icon="ph:plus-bold" />
        </IconButton>
      )} */}

      {!hideNavigationControl && <NavigationControl position="bottom-left" />}
    </>
  );
}
